var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CardWrapper",
    {
      staticClass: "make-topup-widget",
      attrs: {
        "data-test-id": "make-topup-widget",
        title: _vm.i18n.topup_refill()
      }
    },
    [
      _vm.accountVerified
        ? [
            _c(
              "div",
              {
                class: [
                  "make-topup-widget__step",
                  { active: _vm.checkActiveStep(1) }
                ],
                attrs: { "data-test-id": "make-topup-widget-first-step" }
              },
              [
                _c(
                  "StepTitle",
                  {
                    attrs: { stepNumber: "1" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.setCurrentStep(1)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "make-topup-widget__step-title" },
                      [
                        _c(
                          "p",
                          {
                            attrs: {
                              "data-test-id":
                                "make-topup-widget-first-step-title"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.i18n.lbl_choose_asset()) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.selectedAsset && !_vm.checkActiveStep(1),
                                expression:
                                  "selectedAsset && !checkActiveStep(1)"
                              }
                            ],
                            attrs: {
                              "data-test-id": "make-topup-widget-selected-asset"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.selectedAsset) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "AccordeonWrapper",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.checkActiveStep(1),
                        expression: "checkActiveStep(1)"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "make-topup-widget__step-inner",
                        attrs: {
                          "data-test-id":
                            "make-topup-widget-first-step-container"
                        }
                      },
                      [
                        _c("SelectWrapper", {
                          attrs: {
                            options: _vm.cryptoAssets,
                            selected: _vm.selectedAsset,
                            "data-test-id": "make-topup-widget-asset-select"
                          },
                          on: {
                            setSelected: function($event) {
                              return _vm.setSelectedAsset($event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  "make-topup-widget__step",
                  { active: _vm.checkActiveStep(2) }
                ],
                attrs: { "data-test-id": "make-topup-widget-second-step" }
              },
              [
                _c(
                  "StepTitle",
                  {
                    attrs: { stepNumber: "2" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.setCurrentStep(2)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.i18n.lbl_one_time_wallet_address()) +
                        "\n        "
                    ),
                    _c(
                      "md-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.selectedAsset && _vm.checkActiveStep(2),
                            expression: "selectedAsset && checkActiveStep(2)"
                          }
                        ],
                        staticClass:
                          "md-icon-button md-raised make-topup-widget__tooltip-button",
                        attrs: {
                          "data-test-id": "make-topup-widget-tooltip-btn"
                        }
                      },
                      [
                        _c("md-icon", {
                          attrs: { "md-src": "/static/img/info-icon.svg" }
                        }),
                        _vm._v(" "),
                        _c(
                          "md-tooltip",
                          {
                            staticClass: "custom-tooltip",
                            attrs: {
                              "md-direction": "bottom",
                              "data-test-id": "make-topup-widget-tooltip"
                            }
                          },
                          [
                            _vm.minAmounts[_vm.selectedAssetWithoutSpace]
                              ? [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.i18n.topup_how_much({
                                          asset: _vm.selectedAsset,
                                          value:
                                            _vm.minAmounts[
                                              _vm.selectedAssetWithoutSpace
                                            ]
                                        })
                                      ) +
                                      ".\n              " +
                                      _vm._s(_vm.i18n.topup_crypto_minimal()) +
                                      "\n            "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.i18n.topup_network_fee()) +
                                      "\n            "
                                  )
                                ]
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.checkActiveStep(2)
                  ? _c("AccordeonWrapper", [
                      _vm.currentQr
                        ? _c(
                            "div",
                            {
                              staticClass: "make-topup-widget__step-inner",
                              attrs: {
                                "data-test-id":
                                  "make-topup-widget-second-step-container"
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "make-topup-widget__message",
                                  attrs: {
                                    "data-test-id":
                                      "make-topup-widget-timer-message"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.i18n.lbl_wait_30()) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "make-topup-widget__address" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("qrcode", {
                                        style:
                                          "width: 150px; height: 150px; overflow: hidden; margin: 0px auto !important;",
                                        attrs: {
                                          text: _vm.currentQr,
                                          size: 150,
                                          color: "#3f4244",
                                          align: "center",
                                          "data-test-id":
                                            "make-topup-widget-qrcode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "make-topup-widget__address-hash"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "timer-row" },
                                        [
                                          _c("Timer", {
                                            attrs: {
                                              "data-test-id":
                                                "make-topup-widget-timer",
                                              showMessage: false
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "hash-row" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              attrs: {
                                                id: "one-time-wallet-hash",
                                                "data-test-id":
                                                  "make-topup-widget-wallet-hash"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(_vm.currentQr) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-button",
                                            {
                                              staticClass:
                                                "md-icon-button md-raised make-topup-widget__copy-button",
                                              attrs: {
                                                id: "clipboard-btn",
                                                "data-clipboard-target":
                                                  "#one-time-wallet-hash",
                                                "data-test-id":
                                                  "make-topup-widget-copy-hash-btn"
                                              },
                                              on: { click: _vm.copyHash }
                                            },
                                            [
                                              _c("md-icon", [
                                                _vm._v("content_copy")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.createBtn
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "recreate-btn",
                                              attrs: {
                                                type: "button",
                                                "data-test-id":
                                                  "make-topup-widget-recreate-wallet-btn"
                                              },
                                              on: { click: _vm.resetQrByBtn }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.i18n.lbl_create_btn()
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "make-topup-widget__step-inner loading",
                              attrs: {
                                "data-test-id": "make-topup-widget-loading"
                              }
                            },
                            [_c("p", [_vm._v(_vm._s(_vm.i18n.lbl_loading()))])]
                          )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        : _c(
            "div",
            {
              staticClass: "make-topup-widget__not-verified",
              attrs: { "data-test-id": "make-topup-widget-not-verified" }
            },
            [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.getMessage()) },
                on: { click: _vm.handleGoToVerification }
              })
            ]
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5898588b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5898588b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/MakeTopupWidget.vue
// module id = F0mn
// module chunks = 1